import { render, staticRenderFns } from "./newmannterms.vue?vue&type=template&id=59a5c9bc&scoped=true&"
import script from "./newmannterms.vue?vue&type=script&lang=js&"
export * from "./newmannterms.vue?vue&type=script&lang=js&"
import style0 from "./newmannterms.vue?vue&type=style&index=0&id=59a5c9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a5c9bc",
  null
  
)

export default component.exports